import { useQuery } from '@tanstack/react-query';
import { MRT_ColumnFiltersState } from 'material-react-table';
import { forwardRef } from 'react';

import Select, { Option } from '../govuk/Select';
import { Ellipsis } from '../Spinner';
import { listSurveysQuery } from '../tables/SurveyTable';
import { DropdownProps } from './DropdownTypes';

interface SurveyDropdownProps extends DropdownProps {
  columnFilters?: MRT_ColumnFiltersState;
}

const SurveyDropdown = forwardRef<HTMLSelectElement, SurveyDropdownProps>(
  ({ label = 'Survey', columnFilters, ...props }: SurveyDropdownProps, ref) => {
    const { data, isLoading } = useQuery(
      listSurveysQuery({
        pageIndex: 0,
        pageSize: -1,
        columnFilters: columnFilters,
      }),
    );

    if (isLoading) return <Ellipsis />;

    return (
      <Select label={label} ref={ref} {...props}>
        <Option key={0} value="0" text="Choose survey" disabled={true} />
        {data?.data?.map((item) => (
          <Option key={item.survey_id} value={item.survey_id?.toString()} text={item.survey_name} />
        ))}
      </Select>
    );
  },
);
SurveyDropdown.displayName = 'SurveyDropdown';

export { SurveyDropdown };
